export default __webpack_public_path__ + "static/media/rheinerft2_dark.8443af76.png";